import { useMemo } from 'react';

import filter from '@Components/Grid/utils/filter';

export default function useFilters() {
  return useMemo(() => [
    filter.boolean('active', 'Active'),
    filter
      .options.list('type', 'Type', TYPE_OPTIONS)
      .multi(true),
    filter
      .options.list('rules', 'With Rules', WITH_RULES_OPTIONS)
      .getValue(value => JSON.stringify(value))
      .setValue(value => JSON.parse(value)),
    filter
      .options.list('integrationData', 'Multi Buyer', MULTI_BUYER_OPTIONS)
      .getValue(value => JSON.stringify(value))
      .setValue(value => JSON.parse(value)),
    filter
      .options.store('cfid_number', 'Custom Field', 'customFields'),
  ], [])
}

const TYPE_OPTIONS = [
  { label: 'Account Password', value: 'account-pw' },
  { label: 'HTML', value: 'html' },
  { label: 'iframe', value: 'iframe' },
  { label: 'Covalent', value: 'partner-covalent' },
  { label: 'Ifficient', value: 'partner-ifficient' },
  { label: 'Nitro', value: 'partner-nitro' },
  { label: 'Fluent', value: 'partner-fluent' },
  { label: 'Opt-Intelligence', value: 'partner-optintelligence' },
  { label: 'Permission Data', value: 'partner-permissiondata' },
  { label: 'RexAdz', value: 'partner-rexadz' },
  { label: 'React2Media', value: 'partner-react2' },
  { label: 'Tiburon', value: 'partner-tiburon' },
  { label: 'Twyne', value: 'partner-twyne' },
  { label: 'TCPA Confirmation', value: 'tcpa-confirmation' },
  { label: 'TCPA Question', value: 'tcpa-question' },
  { label: 'TCPA Form', value: 'tcpa-form' },
  { label: 'TCPA Linkout Question', value: 'tcpa-linkout-question' },
  { label: 'TCPA ClickToCall Question', value: 'tcpa-call-question' },
  { label: 'TCPA Question Custom', value: 'tcpa-question-custom' },
]

const WITH_RULES_OPTIONS = [
  { label: 'True', value: '{"$not":null}' },
  { label: 'False', value: '{"$eq":null}' },
]

const MULTI_BUYER_OPTIONS = [
  { label: 'True', value: '{"$regexp":"\\"integrationId\\":[^n]"}' },
  { label: 'False', value: '{"$notRegexp":"\\"integrationId\\":[^n]"}' },
]
